import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static targets = ["checkbox", "submit", "tooltip"]

  connect() {
    this.modal = this.element.closest(".modal")
    this.resetConfirmation = () => this.reset()
    this.tooltip = null
    this.ensureTooltip()

    if (this.modal) {
      this.modal.addEventListener("show.bs.modal", this.resetConfirmation)
    }

    this.toggle()
  }

  disconnect() {
    if (this.modal && this.resetConfirmation) {
      this.modal.removeEventListener("show.bs.modal", this.resetConfirmation)
    }

    this.disposeTooltip()
  }

  toggle() {
    if (!this.hasCheckboxTarget || !this.hasSubmitTarget) return

    const confirmed = this.checkboxTarget.checked

    this.submitTarget.disabled = !confirmed
    this.submitTarget.classList.toggle("pe-none", !confirmed)

    if (confirmed) {
      this.disposeTooltip()
      this.tooltipTarget.removeAttribute("tabindex")
    } else {
      this.tooltipTarget.setAttribute("tabindex", "0")
      this.ensureTooltip()
    }
  }

  showReminder(event) {
    if (this.checkboxTarget.checked) return

    event.preventDefault()
    this.ensureTooltip()
    this.tooltip.show()
  }

  reset() {
    if (!this.hasCheckboxTarget) return

    this.checkboxTarget.checked = false
    this.toggle()
  }

  ensureTooltip() {
    if (!this.hasTooltipTarget || this.tooltip) return

    this.tooltip = Tooltip.getOrCreateInstance(this.tooltipTarget)
  }

  disposeTooltip() {
    if (!this.hasTooltipTarget) return

    const tooltipId = this.tooltipTarget.getAttribute("aria-describedby")
    const tooltip = this.tooltip || Tooltip.getInstance(this.tooltipTarget)
    if (tooltip) tooltip.dispose()

    if (tooltipId) {
      document.getElementById(tooltipId)?.remove()
    }

    this.removeMatchingTooltipElement()
    this.tooltipTarget.removeAttribute("aria-describedby")
    this.tooltip = null
  }

  removeMatchingTooltipElement() {
    const title = this.tooltipTarget.getAttribute("data-bs-original-title") || this.tooltipTarget.getAttribute("title")
    if (!title) return

    document.querySelectorAll(".tooltip").forEach((tooltipElement) => {
      if (tooltipElement.textContent.trim() === title) {
        tooltipElement.remove()
      }
    })
  }
}
